import { render, staticRenderFns } from "./ver_pendientes.vue?vue&type=template&id=087015c8&scoped=true"
import script from "./ver_pendientes.vue?vue&type=script&lang=js"
export * from "./ver_pendientes.vue?vue&type=script&lang=js"
import style0 from "./ver_pendientes.vue?vue&type=style&index=0&id=087015c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087015c8",
  null
  
)

export default component.exports